import { useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Avatar,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import GoogleIcon from "@mui/icons-material/Google";
import DeleteIcon from "@mui/icons-material/Delete";
import { useTranslation } from "react-i18next";
import { useAuth } from "@context/AuthContext";
import { PAGE_CONTAINER_SX } from "@/constants/layout";

export default function Account() {
  const { t } = useTranslation();
  const { user, isAuthenticated, loading, loginWithGoogle, deleteAccount } =
    useAuth();
  const [deleteOpen, setDeleteOpen] = useState(false);

  const handleDelete = async () => {
    await deleteAccount();
    setDeleteOpen(false);
  };

  if (loading) {
    return (
      <Box sx={{ p: 4, textAlign: "center" }}>
        <Typography>{t("common.loading")}</Typography>
      </Box>
    );
  }

  if (!isAuthenticated) {
    return (
      <Box
        sx={{
          p: 4,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "60vh",
        }}
      >
        <Card sx={{ maxWidth: 400, width: "100%", textAlign: "center" }}>
          <CardContent sx={{ py: 5 }}>
            <Typography
              variant="h5"
              gutterBottom
              sx={{
                fontWeight: 600,
              }}
            >
              {t("account.title")}
            </Typography>
            <Button
              variant="contained"
              startIcon={<GoogleIcon />}
              onClick={loginWithGoogle}
              sx={{ mt: 2, borderRadius: 9999 }}
            >
              {t("account.signIn")}
            </Button>
          </CardContent>
        </Card>
      </Box>
    );
  }

  return (
    <Box sx={PAGE_CONTAINER_SX}>
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          fontWeight: 600,
        }}
      >
        {t("account.title")}
      </Typography>
      <Card sx={{ maxWidth: 400 }}>
        <CardContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
            py: 4,
          }}
        >
          <Avatar
            sx={{
              width: 64,
              height: 64,
              bgcolor: "primary.main",
              fontSize: 28,
            }}
          >
            {user?.email?.charAt(0).toUpperCase()}
          </Avatar>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 500,
            }}
          >
            {user?.email}
          </Typography>
          <Button
            variant="outlined"
            color="error"
            startIcon={<DeleteIcon />}
            onClick={() => setDeleteOpen(true)}
            sx={{ mt: 2 }}
          >
            {t("account.deleteAccount")}
          </Button>
        </CardContent>
      </Card>
      <Dialog open={deleteOpen} onClose={() => setDeleteOpen(false)}>
        <DialogTitle>{t("account.deleteAccount")}</DialogTitle>
        <DialogContent>
          <DialogContentText>{t("account.deleteConfirm")}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteOpen(false)}>
            {t("common.cancel")}
          </Button>
          <Button onClick={handleDelete} color="error" variant="contained">
            {t("common.delete")}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
